module.exports = __webpack_public_path__ + "img/white-right-bottom.0e337356.png";